const userLegacySettings = (
  userDetails = {},
  userLocation = {},
  userSettings = {},
  legacyEntitlements = [],
  favorites = [],
) => {
  const user = {
    user_id: userDetails && userDetails.legacyId ? userDetails.legacyId : -1,
    ip: userLocation && userLocation.ip ? userLocation.ip : '0.0.0.0',
    favorites,
    units: userSettings && userSettings.surfHeight === 'FT' ? 'e' : 'm',
    type: 'non-registered',
    warningType: userDetails && userDetails.warningType ? userDetails.warningType : null,
  };
  const type = legacyEntitlements.filter(value => (value.company === 'bw'))
  .reduce((result, value) => {
    let resultType;
    if (value.userType_alias === 'bwpremium') {
      if (value.isActive === true) {
        resultType = 'premium';
      } else {
        resultType = 'expired';
      }
    } else if (value.userType_alias === 'bw_basic') {
      resultType = 'registered';
    }
    return resultType;
  }, 'non-registered');

  return {
    ...user,
    type,
  };
};

export default userLegacySettings;



// WEBPACK FOOTER //
// ./src/utils/user/settings.js